import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { registerUser } from "../authServices";
import { doc, setDoc, Timestamp } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import { db } from "../../../Firebase";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import "./Inscription.css";
import { CONNEXION_NAVIGATION } from "../../../Routes/NAVIGATION_PATH";

export default function Inscription() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const onSubmit = (data) => {
    const { nom, prenom, email, confirmPassword, password } = data;
    if (confirmPassword === password) {
      registerUser(email, password)
        .then((userCredential) => {
          toast.success("Admin crée avec succès!");
          const user = userCredential.user;
          setDoc(doc(db, "users", user.uid), {
            prenom: prenom,
            nom: nom,
            email: email,
            user_type: "admin",
            registeredAt: Timestamp.fromDate(new Date()),
          });
          navigate("/");
        })
        .catch((error) => {
          const errorCode = error.code;
          if (errorCode === 'auth/email-already-in-use') {
            toast.error("Utilisateur existant !");
            reset();
          }else if(errorCode === 'auth/weak-password'){
            toast.warning("Mot de passe faible, utlisez minimum 6 caractères !")
          }else if(errorCode === 'email-already-in-use'){
            toast.warning("Email déjà utiliser !")
          }else if(errorCode === "auth/invalid-email"){
            toast.error("Adresse Email non valide !")
          }
          console.log(errorCode);
        });
    } else {
      toast.error("Mots de passe ne correspond pas");
    }
  };

  return (
    <div className="container-fluid inscription d-flex justify-content-center align-items-center min-vh-100 flex-column">
      <div className="row my-contenar">
        <div className="text-center">
          <div className="container-logo">
            <h2>Admin Inscription</h2>
            <p>
              vous avez déjà un compte ?
              <Link to = {'/'} className="SpanEnre">Connectez-vous !</Link>
            </p>
          </div>
        </div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="" controlId="formBasicEmail">
            <Form.Label> Nom</Form.Label>
            <Form.Control {...register("nom")} type="text" placeholder="nom" />
          </Form.Group>
          <Form.Group className="" controlId="formBasicEmail">
            <Form.Label> Prenom</Form.Label>
            <Form.Control
              {...register("prenom")}
              type="text"
              placeholder="prenom"
            />
          </Form.Group>
          <Form.Group className="" controlId="formBasicEmail">
            <Form.Label>Adresse email </Form.Label>
            <Form.Control
              {...register("email")}
              type="email"
              placeholder="Enter email"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>mot de pass</Form.Label>
            <Form.Control
              {...register("password")}
              type="password"
              placeholder="Password"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>mot de pass</Form.Label>
            <Form.Control
              {...register("confirmPassword")}
              type="password"
              placeholder="confirmation password"
            />
          </Form.Group>
          <ToastContainer />
          <button type="submit" className="block-btn">
            S'inscrire
          </button>
        </Form>
      </div>
    </div>
  );
}
